import Legend from 'ol-ext/legend/Legend';
import LegendCtrl from 'ol-ext/control/Legend';
import Image from 'ol-ext/legend/Image';
import {Circle, Fill, Stroke, Style,RegularShape,Icon} from 'ol/style.js';
import {miejscowosci} from './source.js';
import {drogi,akweny,rzeki,bagna,lasy} from './source.js';
import {archidiakonaty,diecezje,dekanaty,parafie,powiaty,ziemie,wojewodztwa} from './source.js';

var legend = new Legend({ 
    margin: 5,
    maxWidth: 300
  });
export var legendCtrl = new LegendCtrl({
    target: $("#nav-legend").get(0),
    legend: legend,
    collapsed: false
  });

  // New legend associated with a layer
var miejscowosciLegend = new Legend({ layer: miejscowosci,margin:5})
var miejscowosci_icons = { miasto:'miasto.png', 'wieś': 'wies.png', 'inna osada':'inne.png', rejestr: 'rejestr.png'};
for (var i in miejscowosci_icons) {
    miejscowosciLegend.addItem({ 
    title: i,
    typeGeom:'Point', 
    style: new Style({
      image: new Icon(({
        scale:0.2,
        src: "./assets/images/" + miejscowosci_icons[i],  
    }))
    })
  });
}

legend.addItem(miejscowosciLegend)


const layersLegend = [

  //church distrcts
  { layer: diecezje, title: 'diecezje', icon: './assets/images/diecezje.png', scale: 0.12 },
  { layer: archidiakonaty, title: 'archidiakonaty', icon: './assets/images/archidiakonaty.png', scale: 0.12 },
  { layer: dekanaty, title: 'dekanaty', icon: './assets/images/dekanaty.png', scale: 0.12 },
  { layer: parafie, title: 'parafie', icon: './assets/images/parafie.png', scale: 0.12 },

  //counties
  { layer: wojewodztwa, title: 'województwa', icon: './assets/images/wojewodztwa.png', scale: 0.12 },
  { layer: ziemie, title: 'ziemie', icon: './assets/images/ziemie.png', scale: 0.12 },
  { layer: powiaty, title: 'powiaty', icon: './assets/images/powiaty.png', scale: 0.12 },

  //terrain coverage
  { layer: drogi, title: 'drogi', icon: './assets/images/drogi.png', scale: 0.12 },
  { layer: rzeki, title: 'rzeki', icon: './assets/images/rzeki.png', scale: 0.12 },
  { layer: akweny, title: 'akweny', icon: './assets/images/akweny.png', scale: 0.12 },
  { layer: bagna, title: 'bagna', icon: './assets/images/bagna.png', scale: 0.12 },
  { layer: lasy, title: 'lasy', icon: './assets/images/lasy.png', scale: 0.12 },
]

// loop through the layers and add them to the legend
layersLegend.forEach(({ layer, title, icon, scale }) => {
  const layerLegend = new Legend({ layer: layer, margin: 5 });
  layerLegend.addItem({ 
      title: title,
      typeGeom: 'Point',
      style: new Style({
          image: new Icon({
              scale: scale,
              src: icon,
          }),
      }),
  });
  legend.addItem(layerLegend);
});







// //New legend associated with a layer
// var drogiLegend = new Legend({ layer: drogi,margin:4})
// var akwenyLegend = new Legend({layer:akweny,margin:4})
// var rzekiLegend = new Legend({layer:rzeki,margin:4})
// var bagnaLegend = new Legend({layer:bagna,margin:4})
// var lasyLegend = new Legend({layer:lasy,margin:4})

// var diecezjeLegend = new Legend({layer:diecezje,margin:4})
// var archidiakonatyLegend = new Legend({ layer: archidiakonaty,margin:4})
// var dekanatyLegend = new Legend({layer:dekanaty,margin:4})
// var parafieLegend = new Legend({layer:parafie,margin:4})
// var powiatyLegend = new Legend({layer:powiaty,margin:4})
// var ziemieLegend = new Legend({layer:ziemie,margin:4})
// var wojewodztwaLegend = new Legend({layer:wojewodztwa,margin:4})


// drogiLegend.addItem(new Image({
//   title: 'Drogi',
//   typeGeom:'Line',
//   width:30,
//   src: 'https://data.atlasfontium.pl/geoserver/ows?service=WMS&request=GetLegendGraphic&format=image/png&layer=geonode:drogi'
// }))

// akwenyLegend.addItem(new Image({
//     title: 'Jeziora i rzeki główne',
//     width:30,
//     src: 'https://data.atlasfontium.pl/geoserver/ows?service=WMS&request=GetLegendGraphic&format=image/png&layer=geonode:akweny'
// }))

// rzekiLegend.addItem(new Image({
//     title: 'Rzeki',
//     width:30,
//     src: 'https://data.atlasfontium.pl/geoserver/ows?service=WMS&request=GetLegendGraphic&format=image/png&layer=geonode:rzeki'
// }))

// bagnaLegend.addItem(new Image({
//     title: 'Bagna',
//     width:30,
//     src: 'https://data.atlasfontium.pl/geoserver/ows?service=WMS&request=GetLegendGraphic&format=image/png&layer=geonode:bagna'
// }))

// lasyLegend.addItem(new Image({
//     title: 'Lasy',
//     width:30,
//     src: 'https://data.atlasfontium.pl/geoserver/ows?service=WMS&request=GetLegendGraphic&format=image/png&layer=geonode:lasy'
// }))

// archidiakonatyLegend.addItem(new Image({
//   title: 'Archidiakonaty',
//   typeGeom:'Line',
//   width:30,
//   src: 'https://data.atlasfontium.pl/geoserver/ows?service=WMS&request=GetLegendGraphic&format=image/png&layer=geonode:archidiakonaty'
// }))

// diecezjeLegend.addItem(new Image({
//     title: 'Diecezje',
//     width:30,
//     src: 'https://data.atlasfontium.pl/geoserver/ows?service=WMS&request=GetLegendGraphic&format=image/png&layer=geonode:diecezje'
// }))

// dekanatyLegend.addItem(new Image({
//   title: 'Dekanaty',
//   width:30,
//   src: 'https://data.atlasfontium.pl/geoserver/ows?service=WMS&request=GetLegendGraphic&format=image/png&layer=geonode:dekanaty0'
// }))

// parafieLegend.addItem(new Image({
//     title: 'Parafie',
//     width:30,
//     src: 'https://data.atlasfontium.pl/geoserver/ows?service=WMS&request=GetLegendGraphic&format=image/png&layer=geonode:parafie10'
// }))

// wojewodztwaLegend.addItem(new Image({
//     title: 'Województwa',
//     width:30,
//     src: './assets/images/wojewodztwa_legenda.png'
// }))

// ziemieLegend.addItem(new Image({
//   title: 'Ziemie',
//   width:30,
//   src: './assets/images/ziemie_legenda.png'
// }))

// powiatyLegend.addItem(new Image({
//     title: 'Powiaty',
//     width:30,
//     src: './assets/images/powiaty_legenda.png'
// }))

// legend.addItem(miejscowosciLegend)
// legend.addItem(drogiLegend)
// legend.addItem(akwenyLegend)
// legend.addItem(rzekiLegend)
// legend.addItem(bagnaLegend)
// legend.addItem(lasyLegend)
// legend.addItem(diecezjeLegend)
// legend.addItem(archidiakonatyLegend)
// legend.addItem(dekanatyLegend)
// legend.addItem(parafieLegend)
// legend.addItem(wojewodztwaLegend)
// legend.addItem(ziemieLegend)
// legend.addItem(powiatyLegend)

